import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/V3LoadingScreen.css';

const V3LoadingScreen = () => {
    const { i18n } = useTranslation();
    const [currentTextIndex, setCurrentTextIndex] = useState(0);
    
    // Loading texts for different languages
    const loadingTexts = {
        en: [
            'Loading',
            'Preparing',
            'Cooking',
            'Marinating',
            'Brewing',
            'Assembling',
            'Gathering',
            'Collecting',
            'Processing',
            'Initializing',
            'Synchronizing',
            'Connecting',
            'Fetching',
            'Building',
            'Constructing',
            'Organizing',
            'Arranging',
            'Compiling',
            'Generating',
            'Creating'
        ],
        es: [
            'Cargando',
            'Preparando',
            'Cocinando',
            'Marinando',
            'Elaborando',
            'Ensamblando',
            'Reuniendo',
            'Recolectando',
            'Procesando',
            'Inicializando',
            'Sincronizando',
            'Conectando',
            'Obteniendo',
            'Construyendo',
            'Armando',
            'Organizando',
            'Arreglando',
            'Compilando',
            'Generando',
            'Creando'
        ],
        ru: [
            'Загрузка',
            'Подготовка',
            'Готовим',
            'Маринуем',
            'Варим',
            'Собираем',
            'Накапливаем',
            'Коллекционируем',
            'Обрабатываем',
            'Инициализируем',
            'Синхронизируем',
            'Подключаемся',
            'Получаем',
            'Строим',
            'Конструируем',
            'Организуем',
            'Упорядочиваем',
            'Компилируем',
            'Генерируем',
            'Создаем'
        ]
    };
    
    const currentLang = i18n.language || 'en';
    const texts = loadingTexts[currentLang] || loadingTexts.en;
    
    // Change text every 1.5 seconds
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentTextIndex(prev => (prev + 1) % texts.length);
        }, 1500);
        
        return () => clearInterval(interval);
    }, [texts.length]);
    
    // Randomize initial text
    useEffect(() => {
        setCurrentTextIndex(Math.floor(Math.random() * texts.length));
    }, [texts.length]);
    
    return (
        <div className="v3-loading-overlay">
            <div className="v3-loading-content">
                <div className="v3-loading-spinner">
                    <div className="spinner-ring"></div>
                </div>
                <div className="v3-loading-text">
                    {texts[currentTextIndex]}...
                </div>
            </div>
        </div>
    );
};

export default V3LoadingScreen;